module.exports = __webpack_public_path__ + "img/reward.5d2054eb.png";